import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=661c4542&scoped=true&"
import script from "./StatCard.vue?vue&type=script&lang=js&"
export * from "./StatCard.vue?vue&type=script&lang=js&"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=661c4542&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c4542",
  null
  
)

export default component.exports